export default {
  about: "About",
  content: "Content of course",
  steps: "No. of Steps",
  credits: "Credits",
  free: "Free",
  purchased: "Purchased",
  chapter: "Chapter",
  lesson: "Step",
  lessons: "steps",
  buttons: {
    buyAndPlay: "Buy and Start",
    continue: "Continue",
    begin: "Start Course",
    repeat: "Re-play for",
    backToJourney: "Back to course",
  },
  repeatModal: {
    title: "Repeat Course",
    description: "Do you want to start the course again from the beginning?",
    cost: "Cost",
    cancel: "Cancel",
    confirm: "Confirm",
  },
};
